import { render, staticRenderFns } from "./WritingAnimation.vue?vue&type=template&id=b2e4760c&scoped=true&"
import script from "./WritingAnimation.vue?vue&type=script&lang=js&"
export * from "./WritingAnimation.vue?vue&type=script&lang=js&"
import style0 from "./WritingAnimation.vue?vue&type=style&index=0&id=b2e4760c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e4760c",
  null
  
)

export default component.exports